import request from "@/common/js/request.js";

export function saveFile(obj) {
  return request({
    // url: '/user/uploadUserFile',
    url: "/aliyun/oss/putObject",
    method: "post",
    data: obj
  });
}
export function putObj(obj) {
  return request({
    url: "/user/updateUser",
    method: "post",
    params: obj
  });
}
export function getUser(obj) {
  return request({
    url: "/user/getUserByUsername",
    method: "get",
    params: obj
  });
}

export function getUserpaw(obj) {
  return request({
    url: "/user/updatePasswordForPC",
    method: "post",
    params: obj
  });
}

// 获取验证码
export function fetchCode(obj) {
  return request({
    url: "/user/getCaptcha",
    method: "get",
    params: obj
  });
}

// 绑定手机接口
export function fetchbindCell(obj) {
  return request({
    url: "/user/bindCellPhoneWithCaptcha",
    method: "post",
    params: obj
  });
}

// 验证验证码接口
export function fetchCodevalidate(obj) {
  return request({
    url: "/user/validateCaptcha",
    method: "post",
    params: obj
  });
}

//手机登录
export function fetchLoginWithCaptcha(obj) {
  return request({
    url: "/user/userLoginWithCaptcha",
    method: "post",
    params: obj
  });
}
// 登出
export function logout(token) {
  return request({
    url: "/auth/invalid",
    method: "post",
    params: {
      token
    }
  });
}
// 在变更绑定手机号前的身份验证接口
export function fetchupdeCode(obj) {
  return request({
    url: "/user/validateBeforeUpdatingCellPhone",
    method: "post",
    params: obj
  });
}
// 通过安全码重置登录密码接口
export function fetchSecurityCode(obj) {
  return request({
    url: "/user/updatePasswordWithSecurityCode",
    method: "post",
    params: obj
  });
}



// WEBPACK FOOTER //
// ./src/api/user-center/getUser.js